import React, {ChangeEvent} from 'react';
import {cnSettingsMenu, ISettingsMenuGroupProps} from "../SettingsMenu";
import {useTranslation} from 'react-i18next';
import {ISettingGroupGeneral} from '../../../../interfaces/settingData/ISettingGroupGeneral';
import {IOption} from '../../../../../common-code/interfaces/option/IOption';
import {Tumbler} from '../../../components/Tumbler/Tumbler';
import {ObjectOption} from '../../../components/ObjectOption/ObjectOption';
import {cnObjectOption} from '../../../components/ObjectOption';
import {ICreateObjectData} from '../../../../../../../common/interfaces/createData/ICreateObjectData';
import {CreateOption} from '../../CreateOption/CreateOption';
import {CommonObjectHelper} from '../../../../3d/helpers/CommonObjectHelper/CommonObjectHelper';

export interface ISettingsMenuGeneralGroupProps extends ISettingsMenuGroupProps {
    generalData: ISettingGroupGeneral;
    onSetRotation: (value: number) => void;
}

export const SettingsMenuGeneral: React.FC<ISettingsMenuGeneralGroupProps> =
    ({className, data, onRebuildUnitData, generalData}) => {
        const {t} = useTranslation();

        const onRebuildOptionData = (option: IOption, fieldId: string, value: any): boolean => {
            let changeFieldId: string | undefined;

            switch (fieldId) {
                case 'width':
                    changeFieldId = 'length';
                    break;
                case 'height':
                    changeFieldId = 'height';
                    break;
                case 'depth':
                    changeFieldId = 'width';
                    break;
                case 'isFlipX':
                case 'isFlipY':
                    return onRebuildUnitData(
                        'rebuildFlipValue',
                        {fieldId: fieldId, value: value},
                        generalData.parentUnit
                    );
                default:
                    changeFieldId = fieldId;
                    break;
            }
            return onRebuildUnitData(
                'rebuildOtherOption',
                {option: option, fieldId: changeFieldId, value: value},
                generalData.parentUnit
            );
        };
        const handleSizesChange = (fieldId: string, value: any): boolean => {
            let changeFieldId: string | undefined;
            switch (fieldId) {
                case 'width':
                    changeFieldId = 'length';
                    break;
                case 'height':
                    changeFieldId = 'height';
                    break;
                case 'depth':
                    changeFieldId = 'width';
                    break;

            }
            if (changeFieldId && !isNaN(+value)) {
                return onRebuildUnitData(
                    'rebuildCorpusSizes',
                    {name: changeFieldId, value: +value},
                    generalData.parentUnit
                )
            } else {
                console.error('rebuildCorpusSizes', changeFieldId, value);
                return false;
            }
        };
        const createObjectData: ICreateObjectData | undefined = generalData.createObjectData;

        return (
            <div className={cnSettingsMenu('General', [className])}>
                <div className={cnSettingsMenu('Item', {id: 'IsDimensions'})}>
                    {generalData.isDimensions !== undefined && data.isDimensions !== undefined ?
                        <div className={cnSettingsMenu('TumblerItem')}>
                            <p className={cnSettingsMenu('TumblerTitle')}>{t('Учитывать габариты')}</p>
                            <Tumbler
                                className={cnSettingsMenu('TumblerValue')}
                                checked={data.isDimensions}
                                callBack={(event: ChangeEvent<HTMLInputElement>) => {
                                    onRebuildUnitData(
                                        'rebuildIsDimensions',
                                        event.target.checked,
                                        generalData.parentUnit
                                    );
                                }}
                            />
                        </div> : null}
                </div>
                <div className={cnSettingsMenu('Item', {id: 'IsStick'})}>
                    {generalData.isStick !== undefined && data.isStick !== undefined ?
                        <div className={cnSettingsMenu('TumblerItem')}>
                            <p className={cnSettingsMenu('TumblerTitle')}>{t('Прилипание к соседям')}</p>
                            <Tumbler
                                className={cnSettingsMenu('TumblerValue')}
                                checked={data.isStick}
                                callBack={(event: ChangeEvent<HTMLInputElement>) => {
                                    onRebuildUnitData(
                                        'rebuildIsStick',
                                        event.target.checked,
                                        generalData.parentUnit
                                    );
                                }}
                            />
                        </div> : null}
                </div>
                <div className={cnSettingsMenu('Item', {id: 'IsLevelStick'})}>
                    {generalData.isLevelStick !== undefined && data.isLevelStick !== undefined ?
                        <div className={cnSettingsMenu('TumblerItem')}>
                            <p className={cnSettingsMenu('TumblerTitle')}>{t('Прилипание между уровнями')}</p>
                            <Tumbler
                                className={cnSettingsMenu('TumblerValue')}
                                checked={data.isLevelStick}
                                callBack={(event: ChangeEvent<HTMLInputElement>) => {
                                    onRebuildUnitData(
                                        'rebuildIsLevelStick',
                                        event.target.checked,
                                        generalData.parentUnit
                                    );
                                }}
                            />
                        </div> : null}
                </div>
                <div className={cnSettingsMenu('Item', {id: 'IsWallStick'})}>
                    {generalData.isWallStick !== undefined && data.isWallStick !== undefined ?
                        <div className={cnSettingsMenu('TumblerItem')}>
                            <p className={cnSettingsMenu('TumblerTitle')}>{t('Прилипание к стенам')}</p>
                            <Tumbler
                                className={cnSettingsMenu('TumblerValue')}
                                checked={data.isWallStick}
                                callBack={(event: ChangeEvent<HTMLInputElement>) => {
                                    onRebuildUnitData(
                                        'rebuildIsWallStick',
                                        event.target.checked,
                                        generalData.parentUnit
                                    );
                                }}
                            />
                        </div> : null}
                </div>

                {/* <ModulerRotationSlider onSetRotation={onSetRotation}/> */}

                {createObjectData ? generalData.sizes.map((option) => {
                    return (
                        <CreateOption
                            option={CommonObjectHelper.prepareCreateOption(
                                option,
                                createObjectData,
                                createObjectData.disableSelects ? createObjectData.disableSelects['sizes_' + option.id] : undefined,
                                false
                            )}
                            key={option.id}
                            type={option.type}
                            onChange={handleSizesChange}
                            createOptions={{}}
                            objectData={createObjectData}
                        />
                    );
                }) : null}

                {generalData.other.map((option) => {
                    return (<div className={cnSettingsMenu('Item', {id: option.id})} key={option.id}>
                        <ObjectOption
                            type={option.type}
                            option={option}
                            defaultValue={option.defaultValue}
                            value={option.value}
                            className={cnSettingsMenu(cnObjectOption())}
                            onChange={(fieldId: string, value: any) => {
                                onRebuildOptionData(option, fieldId, value);
                            }}
                        />
                    </div>);
                })}
            </div>
        );
    }
